// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calendar-table {
  table-layout: fixed;
}
  
.day-cell {
  height: 100px;
  vertical-align: top;
  cursor: pointer;
  background-color: #f9f9f9;
}

.day-cell:hover {
  /* background-color: #e9ecef; */
  /* background-color: #f2f3f5 !important; Color de fondo para el hover */
  transition: background-color 0.3s ease; /* Animación suave */

}

.routine-item {
  padding: 2px 10px;
  margin-top: 5px;
  margin-left: 0;
  border-radius: 4px;
  font-size: 12px;
  list-style: none;
}
.rutina {
  /* background-color: #d1ecf1; */
  /* color: #0c5460; */
  /* background-color: #f1d1d1; */
  background-color: #ffffff;
  color: #000000;
}
.dia-libre {
  /* background-color: #d2f1d1; */
  background-color: #ffffff;
  color: #000000;
}
  





  .calendar-table {
    table-layout: fixed;
  }
  
  .day-cell {
    height: 100px;
    vertical-align: top;
    cursor: pointer;
    background-color: #f9f9f9;
    border: 1px solid #ddd;
  }
  
  .day-cell:hover {
    background-color: #e9ecef;
  }
  
  .selected {
    border: 2px solid #007bff;
    background-color: #cce5ff !important;
  }
  
  .list-group-item {
    cursor: pointer;
  }
  
  /* .list-group-item button {
    visibility: hidden;
  }
  
  .list-group-item:hover button {
    visibility: visible;
  } */

.ql-container.ql-snow{
  height: 50vh!important;
}
  `, "",{"version":3,"sources":["webpack://./src/app/modules/trainer-dashboard/programas/config-avanzada/calendario/calendario.component.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,uEAAuE;EACvE,sCAAsC,EAAE,oBAAoB;;AAE9D;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,+BAA+B;EAC/B,oBAAoB;EACpB,+BAA+B;EAC/B,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,cAAc;AAChB;;;;;;;EAOE;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,oCAAoC;EACtC;;EAEA;IACE,eAAe;EACjB;;EAEA;;;;;;KAMG;;AAEL;EACE,sBAAsB;AACxB","sourcesContent":[".calendar-table {\n  table-layout: fixed;\n}\n  \n.day-cell {\n  height: 100px;\n  vertical-align: top;\n  cursor: pointer;\n  background-color: #f9f9f9;\n}\n\n.day-cell:hover {\n  /* background-color: #e9ecef; */\n  /* background-color: #f2f3f5 !important; Color de fondo para el hover */\n  transition: background-color 0.3s ease; /* Animación suave */\n\n}\n\n.routine-item {\n  padding: 2px 10px;\n  margin-top: 5px;\n  margin-left: 0;\n  border-radius: 4px;\n  font-size: 12px;\n  list-style: none;\n}\n.rutina {\n  /* background-color: #d1ecf1; */\n  /* color: #0c5460; */\n  /* background-color: #f1d1d1; */\n  background-color: #ffffff;\n  color: #000000;\n}\n.dia-libre {\n  /* background-color: #d2f1d1; */\n  background-color: #ffffff;\n  color: #000000;\n}\n  \n\n\n\n\n\n  .calendar-table {\n    table-layout: fixed;\n  }\n  \n  .day-cell {\n    height: 100px;\n    vertical-align: top;\n    cursor: pointer;\n    background-color: #f9f9f9;\n    border: 1px solid #ddd;\n  }\n  \n  .day-cell:hover {\n    background-color: #e9ecef;\n  }\n  \n  .selected {\n    border: 2px solid #007bff;\n    background-color: #cce5ff !important;\n  }\n  \n  .list-group-item {\n    cursor: pointer;\n  }\n  \n  /* .list-group-item button {\n    visibility: hidden;\n  }\n  \n  .list-group-item:hover button {\n    visibility: visible;\n  } */\n\n.ql-container.ql-snow{\n  height: 50vh!important;\n}\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
